import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Observable } from "rxjs";
import { IParamsCollection } from "src/app/core/jsonapi/interfaces/params-collection";
import { ResponseCollection } from "src/app/core/jsonapi/responses/response-collection";
import { Dasboard } from "../_type/dashboard";
import { ParamsBuilder } from "src/app/core/jsonapi/params/params-builder";

@Injectable({
    providedIn: 'root',
})

export class DashboardService extends Service<Dasboard> {
  public override type = 'dashboard';
  public override url = 'attendance/dashboard'; 


    public getInfo(params: any): Observable<any> {
        let url = this.getAPIUrl()+"/cases/info/";   
        url += "?"+ params;
        
        return this.http.get<any>(url);
    }

    public getInfoToolbar(userId: string): Observable<any> {
        let url = this.getAPIUrl() + "/"+ userId + "/cases/info/toolbar";
        this.loaderService.skipRequest(url);
        return this.http.get<any>(url);
    }
}
